import { makeAutoObservable } from 'mobx'

export type ImageState = 'none' | 'load' | 'error'

export class ImageStore {
  state: ImageState = 'none'
  readonly source?: string

  constructor(source: string | undefined) {
    makeAutoObservable(this)
    this.source = source
  }

  get ready(): boolean {
    return this.state === 'load'
  }

  readonly onLoad = () => {
    this.state = 'load'
  }

  readonly onError = () => {
    this.state = 'error'
  }
}
